// BuildCategoryRail — compact vertical edge strip for ACTIVE EM²c categories.

import React from "react";
import { EM2C_CATEGORIES } from "../game/data/em2c-buildings";
import {
  Zap, Home, Wrench, Wind, Pickaxe, Factory, Package, Cog, Rocket,
  FlaskConical, Radio, Info, ClipboardList,
} from "lucide-react";

const CAT_ICON = {
  core: Radio,
  habitation: Home,
  medical: Wrench,
  life: Wind,
  power: Zap,
  mining: Pickaxe,
  manufacturing: Factory,
  storage: Package,
  drones: Cog,
  spaceport: Rocket,
  research: FlaskConical,
  gas: Wind,
};

export default function BuildCategoryRail({ activeCategory, panelOpen, onSelectCategory, onOpenCodex }) {
  return (
    <div
      className="absolute left-0 top-1/2 -translate-y-1/2 z-30 w-14 flex flex-col items-center gap-0.5 bg-[#0A0C10]/90 backdrop-blur-md border border-l-0 border-white/10 py-2 pointer-events-auto"
      style={{ fontFamily: "Rajdhani, sans-serif" }}
      data-testid="build-category-rail"
    >
      <div className="text-[9px] font-mono uppercase tracking-widest text-slate-500 px-2 pb-1.5 border-b border-white/10 mb-1 w-full text-center">
        Build
      </div>

      <button
        type="button"
        data-testid="open-building-directory"
        title="Buildings: status, controls and locate"
        onClick={() => window.dispatchEvent(new CustomEvent("mars:toggle-directory"))}
        className="flex items-center justify-center w-11 h-11 mx-1 text-cyan-300 border border-cyan-500/30 hover:bg-cyan-500/15"
      >
        <ClipboardList size={21} strokeWidth={1.9} />
      </button>
      <div className="w-6 border-t border-white/10 my-1" />

      {EM2C_CATEGORIES.map((c) => {
        const Icon = CAT_ICON[c.id] || Zap;
        const active = panelOpen && activeCategory === c.id;
        return (
          <button
            key={c.id}
            data-testid={`cat-${c.id}`}
            title={c.label}
            onClick={() => onSelectCategory(c.id)}
            className={`group relative flex items-center justify-center w-11 h-11 mx-1 transition-colors ${
              active ? "bg-cyan-500/15 text-cyan-400" : "text-slate-400 hover:text-white hover:bg-white/5"
            }`}
            style={active ? { boxShadow: "inset 3px 0 0 #00e5ff" } : {}}
          >
            <Icon size={21} strokeWidth={1.9} />
            <span className="absolute left-full ml-2 px-2 py-1 bg-[#0A0C10]/98 border border-white/15 text-[10px] font-mono uppercase tracking-widest text-white whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-150">
              {c.label}
            </span>
          </button>
        );
      })}

      <div className="w-6 border-t border-white/10 my-1" />

      <button
        data-testid="btn-open-codex"
        title="Codex"
        onClick={onOpenCodex}
        className="flex items-center justify-center w-11 h-11 mx-1 text-slate-400 hover:text-cyan-400 hover:bg-white/5 transition-colors"
      >
        <Info size={20} strokeWidth={1.9} />
      </button>
    </div>
  );
}
